import React from "react";
import { CodedProperty, ensure } from "sprint-common-web";

import { RecordType } from "../../../../common/types/RecordType";
import { OrderAssetAvailability } from "../../types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../types/OrderAssetStorageType";
import { AssetsAvailabilityList } from "./AssetsAvailabilityList";

export const renderSoundtracksAvailabilityList = <
    T extends {
        soundtracks: {
            availability: OrderAssetAvailability;
            language: CodedProperty;
            isEmbedded?: boolean;
            storageType?: OrderAssetStorageType;
        }[];
    }
>(
    item?: T
): JSX.Element => {
    ensure(item);

    return (
        <AssetsAvailabilityList
            items={item.soundtracks}
            type={OrderAssetStorageType.Cloud}
            testId={"order-cloud-soundtracks-availability-status"}
            assetType={RecordType.Audio}
        />
    );
};
